module.exports = __webpack_public_path__ + "static/media/playbook.880d076a.svg";